import { getMessage } from "../data/locales";

/** @typedef {{ key: string, label: string }} CourseEditorSidebarTab */

/**
 * @returns {CourseEditorSidebarTab[]}
 */
export function getCreateCourseSidebarTabs() {
  return [
    { key: "crearCurso", label: getMessage("courseEditor.tabs.mainData") },
    { key: "crearTest", label: getMessage("courseEditor.tabs.tests") },
    { key: "subirDocumento", label: getMessage("courseEditor.tabs.documents") },
    { key: "vistaGeneral", label: getMessage("courseEditor.tabs.overview") },
    { key: "listadodescuentos", label: getMessage("courseEditor.tabs.discounts") },
    { key: "testimonios", label: getMessage("courseEditor.tabs.testimonials") },
  ];
}

/**
 * @returns {CourseEditorSidebarTab[]}
 */
export function getEditCourseSidebarTabs() {
  return [
    { key: "datos", label: getMessage("courseEditor.tabs.mainData") },
    { key: "tests", label: getMessage("courseEditor.tabs.tests") },
    { key: "docs", label: getMessage("courseEditor.tabs.documents") },
    { key: "vista", label: getMessage("courseEditor.tabs.overview") },
    { key: "descuentos", label: getMessage("courseEditor.tabs.discounts") },
    { key: "testimonios", label: getMessage("courseEditor.tabs.testimonials") },
  ];
}
